import { AController } from "@eagerlogic/react-mvc";
import { ApiException } from "rpc/rpc";
import { ProfileRpc } from "rpc/profile/ProfileRpc";
import { ProfileSettingsModel, EditProfileDialogModel, ChangeImageDialogModel } from "../model/ProfileSettingsModel";

export class ProfileSettingsController extends AController<ProfileSettingsModel> {

    protected createInitialModel(): ProfileSettingsModel {
        var model = new ProfileSettingsModel();
        model.isInit = true;
        this.fetchProfile();
        return model;
    }

    private fetchProfile() {
        ProfileRpc.get().then((res) => {
            this.model.isInit = false;
            this.model.pictureUrl = res.pictureUrl;
            this.model.name = res.name;
            this.model.team = res.team;
            this.model.position = res.position == null ? null : res.position;
            this.model.bio = res.bio == null ? null : res.bio;
            this.model.email = res.email;
            this.model.chatAddress = res.chatAddress;
            this.model.homePhone = res.homePhone;
            this.model.workPhone = res.workPhone;
            this.model.address = res.address;
            this.model.memberSince = res.memberSince;
            this.render(this.model);
        });
    }

    // ---------------------------------------------------------------------
    // Edit profile
    // ---------------------------------------------------------------------

    public onEditProfileClicked() {
        this.model.editProfileDialogModel = new EditProfileDialogModel(
            this.model.name,
            this.model.position,
            this.model.bio,
            this.model.chatAddress,
            this.model.workPhone,
            this.model.homePhone,
            this.model.address,
            this.model.memberSince
        );
        this.render(this.model);
    }

    public onEditProfileCancelClicked() {
        this.model.editProfileDialogModel = null;
        this.render(this.model);
    }

    public onEditProfileSaveClicked(dm: EditProfileDialogModel) {
        dm.nameError = null;
        this.model.editProfileDialogModel = dm;
        this.render(this.model);

        ProfileRpc.save({
            name: dm.name,
            position: dm.position == null ? "" : dm.position,
            bio: dm.bio == null ? "" : dm.bio,
            chat: dm.chat == null ? "" : dm.chat,
            workPhone: dm.workPhone == null ? "" : dm.workPhone,
            homePhone: dm.homePhone == null ? "" : dm.homePhone,
            address: dm.address == null ? "" : dm.address,
            memberSince: dm.memberSince == null ? "" : dm.memberSince
        }).then(() => {
            this.model.editProfileDialogModel = null;
            this.render(this.model);
            this.fetchProfile();
        }).catch((ex: ApiException) => {
            dm.nameError = this.fieldError(ex, "name");
            this.render(this.model);
        });
    }

    // ---------------------------------------------------------------------
    // Change image
    // ---------------------------------------------------------------------

    public onChangeImageClicked() {
        this.model.changeImageDialogModel = new ChangeImageDialogModel();
        this.render(this.model);
    }

    public onChangeImageCancelClicked() {
        this.model.changeImageDialogModel = null;
        this.render(this.model);
    }

    public onChangeImageSaveClicked(imageBase64: string) {
        var dm = this.model.changeImageDialogModel;
        dm.imageError = null;
        this.render(this.model);

        ProfileRpc.uploadImage(imageBase64).then(() => {
            this.model.changeImageDialogModel = null;
            // Bust the browser cache so the freshly uploaded picture is shown.
            this.model.pictureUrl = this.model.pictureUrl.split("&t=")[0] + "&t=" + new Date().getTime();
            this.render(this.model);
        }).catch((ex: ApiException) => {
            dm.imageError = this.fieldError(ex, "image") != null ? this.fieldError(ex, "image") : ex.message;
            this.render(this.model);
        });
    }

    private fieldError(ex: ApiException, field: string): string {
        if (ex != null && ex.fieldErrors != null && ex.fieldErrors[field] != null) {
            return ex.fieldErrors[field];
        }
        return null;
    }

}
